import apiClient from './apiClient';

export const listProceduri     = (clientId)      => apiClient.get(`/clienti/${clientId}/proceduri/`).then(r => r.data);
export const listAllProceduri  = (tips = [])     => apiClient.get('/proceduri/', { params: tips.length ? { tips: tips.join(',') } : {} }).then(r => r.data);
export const createProcedura = (clientId, payload) => apiClient.post(`/clienti/${clientId}/proceduri/`, payload).then(r => r.data);
export const updateProcedura = (procId, payload)  => apiClient.put(`/proceduri/${procId}/`, payload).then(r => r.data);
export const deleteProcedura = (procId)           => apiClient.delete(`/proceduri/${procId}/`).then(r => r.data);
